const cn = {
	language: {
		language: 'EN',
	},
	nav: {
		text1: '保诺服务',
		text2: '保诺产品',
		text3: '全心全意为检测诊断耗材提供定制服务',
		text4: '全自动生产线、先进设备不断研发新产品',
	},
	info: {
		text1: '保诺产品',
		text2: '产品详情',
		text3: '请求异常',
		text4: '产品详情（参数）',
	},
	search: {
		text1: '这里可以搜索您要找的信息',
		text2: '推荐搜索：',
		text3: '暂无数据~',
		text4: '金标卡壳',
		text5: '检测卡壳',
		text6: '试剂卡壳',
		text7: '金标塑料卡',
		text8: '早孕笔杆',
		text9: '联卡系列',
		text10: '灌装加工',
		text11: '请输入搜索内容',
		text12: '点击搜索',
	},
	footer: {
		text1: '关于',
		text2: '保诺塑业（北京）有限公司',
		text3: '联&ensp;&ensp;系&ensp;&ensp;人：蒋经理，86-18601366266',
		text4: '公司地址：北京市房山区窦店工业小区2号',
		text5: '邮&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;编：102433',
		text6: '电话/传真：86-10-69391268',
		text7: '邮&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;箱：<a href="mailto:jiangqiong@bonore.com">jiangqiong@bonore.com</a>',
		text8: '<a href="https://beian.miit.gov.cn/" target="_blank">京ICP备11043213号-1</a>',
	},
	index: {
		text1: '“我们专注为体外诊断试剂行业提供配套耗料和服务性综合型生产”',
		text2: '保诺塑业（北京）有限公司成立于2009年8月，总部位于北京市房山区，分部位于定兴保诺和天津保诺两个分厂。',
		text3: '点击进入',
		text4: '设备环境',
		text5: '查看',
		text6: '国际管理体系认证',
		text7: '通过了IAF/CNAS等国际管理体系认证，我们确保产品质量，做可信赖和依靠的合作伙伴',
		text8: '实力工厂 ｜ 优良货源 ｜ 快捷服务',
		text9: '点击查看',
		text10: '产品中心',
	},
	product: {
		text1: '保诺产品',
		text2: '全部产品',
		text3: '查看',
		text4: '暂无数据~',
		text5: '上一页',
		text6: '下一页',
	},
	news: {
		text1: '点击进入',
		text2: '新闻资讯',
		text3: '正文',
		text4: '数据请求异常',
	},
	contact: {
		text1: '保诺塑业（北京）有限公司',
		text2: '常见问题/专家解答/咨询设备、产品使用问题',
		text3: '联&ensp;&ensp;系&ensp;&ensp;人：蒋经理',
		text4: '联系方式：18601366266',
		text5: '公司地址：北京市房山区窦店工业小区2号',
		text6: '邮&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;编：102433',
		text7: '联系方式：86-10-69391268 / 86-18601366266',
		text8: '传&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;真：86-10-69391268',
		text9: '邮&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;箱：<a href="mailto:jiangqiong@bonore.com">jiangqiong@bonore.com</a>',
		text10: '在线留言',
		text11: '我们有多年行业生产经验',
		text12: '姓&ensp;&ensp;&ensp;&ensp;名：',
		text13: '请输入姓名',
		text14: '电&ensp;&ensp;&ensp;&ensp;话：',
		text15: '请输入联系电话',
		text16: '邮&ensp;&ensp;&ensp;&ensp;箱：',
		text17: '请输入联系邮箱',
		text18: '留&ensp;&ensp;&ensp;&ensp;言：',
		text19: '请输入留言信息',
		text20: '提交留言',
		text21: '提交中...',
		text22: '提交成功',
		text23: '请输入留言信息',
		text24: '我们有多年行业生产经验',
		text25: '提供7*24小时在线服务，马上与我们联系',
		text26: '联系人：18601366266 蒋经理',
		text27: '留下您的信息，我们会在合适的时间联系您',
		text28: '便于联系，请留下您的姓名',
		text29: '便于联系，请留下您的电话',
		text30: '便于联系，请留下您的留言',
	},
	about: {
		text1: '“我们专注为体外诊断试剂行业提供配套耗料和服务性综合型生产”',
		text2: '保诺塑业（北京）有限公司成立于2009年8月，总部位于北京市房山区，分部位于定兴保诺和天津保诺两个分厂。公司专注为体外诊断试剂行业提供配套耗料和服务性综合型生产，产品畅销国内并远销美国、印度、英国、日本、智利等多个国家，受到广大客户一致好评。',
		text3: '公司拥有先进的电动注塑机全自动生产线，注塑机150台、吹塑机6台、各种灌装机120台，是一家集开发、设计、生产和销售的高科技企业，伴随着IVD产业的高速发展不断研发创新产品。',
		text4: '公司坚持质量为上，以诚为本，成为信赖和依靠的合作伙伴！',
		text5: '保诺塑业欢迎各界朋友参观指导、咨询、洽谈业务，真诚期待与您合作！',
		text6: '注塑机 | 台',
		text7: '吹塑机 | 台',
		text8: '灌装设备丨台',
		text9: '保诺塑业箴言',
		text10: '完美品质&ensp;&ensp;真诚服务',
		text11: '规范管理&ensp;&ensp;开拓创新',
	},
	honor: {
		text1: '保诺塑业  同样拥有：',
		text2: '我们的企业质量管理和质量保证能力符合相应标准，有能力按规定的质量要求提供产品。',
		text3: '第一类医疗器械生产备案凭证',
		text4: '保诺塑业（北京）有限公司通过了第一类医料器械备案凭证，生产确保产品质量，是可信赖和依靠的合作伙伴。',
		text5: '实力工厂',
		text6: '优良货源',
		text7: '快捷服务',
		text8: '质量管理体系认证证书',
		text9: 'GB/T19001-2016/ISO9001:2015 标准认证',
		text10: '保诺塑业（北京）有限公司质量管理体系符合 GB/T19001-2016/ISO9001:2015 标准认证覆盖的范围，塑料包装制品（有许可要求的除外）、模具的生产和销售。我们的企业质量管理和质量保证能力符合相应标准，有能力按规定的质量要求提供产品。',
		text11: '中国认可',
		text12: '国际认可',
		text13: 'Quality Management System Certification',
		text14: '·  Approved by China',
		text15: '·  International mutual recognition',
		text16: 'This is to certify the quality management system of Bono Plastics (Beijing) Co., Ltd. conforms to the scope covered by the GB/T19001-2016/ISO9001:2015 standard certification, including the production and sales of plastic packaging products (except those with licensing requirements) and molds.',
		text17: "Our enterprise's quality management and quality assurance capabilities meet the corresponding standards and are capable of providing products according to the specified quality requirements.",
	},
};

export default cn